import { render } from "./TIER-Component.vue?vue&type=template&id=cbc18106&scoped=true"
import script from "./TIER-Component.vue?vue&type=script&lang=js"
export * from "./TIER-Component.vue?vue&type=script&lang=js"

import "./TIER-Component.vue?vue&type=style&index=0&id=cbc18106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc18106"]])

export default __exports__